import React from 'react'

function SizeConversion() {
    return (
        <>
            <div className="inner-offset wow fadeInUp my-4" style={{backgroundColor: "#C8322b"}}>
                <div className="text-center">
                    <h3 style={{color: "white"}}>Quy đổi kích thước</h3>
                </div>
            </div>
        </>
    )
}

export default SizeConversion